module.exports = __webpack_public_path__ + "img/plate02_04.650fb8e0.png";